import React, { useRef, useState, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  openIcon: {
    ...theme.globalClasses.adminTableIcon,
    padding: 0,
    verticalAlign: 'text-bottom',
  },

  dietQualityLink: {
    color: theme.palette.admin.primaryLight,
    fontSize: 14,
    lineHeight: '125%',
    letterSpacing: '0.17px',
    width: '100%',
    '& a': {
      fontWeight: 700,
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      textDecorationSkipInk: 'auto',
      textDecorationThickness: 'auto',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      maxWidth: '100%',
    },
  },
  textContent: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 'calc(100% - 24px)',
    display: 'inline-block',
    marginRight: 3,
  },
}));

const PatientAssessmentLinkComponent = ({ dietQuality = 0, dietName = null, link = null }) => {
  const classes = useStyles();
  const textRef = useRef(null);
  const [isTextTruncated, setIsTextTruncated] = useState(false);
  const fullText = dietQuality && dietName ? `${dietQuality} - ${dietName}` : 'N/A';

  useEffect(() => {
    const checkIfTruncated = () => {
      if (textRef.current) {
        setIsTextTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };

    checkIfTruncated();
    window.addEventListener('resize', checkIfTruncated);

    return () => {
      window.removeEventListener('resize', checkIfTruncated);
    };
  }, [dietQuality, dietName]);

  const renderContent = () => {
    if (!dietQuality) {
      return 'N/A';
    }

    const content = (
      <span
        ref={textRef}
        className={classes.textContent}
      >
        {fullText}
      </span>
    );

    if (link) {
      return (
        <a
          variant="body2"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.dietQualityLink}
        >
          {isTextTruncated ? (
            <Tooltip
              title={fullText}
              arrow
              placement="top"
            >
              {content}
            </Tooltip>
          ) : (
            content
          )}
          <OpenInNew className={classes.openIcon} />
        </a>
      );
    }

    return isTextTruncated ? (
      <Tooltip
        title={fullText}
        arrow
        placement="top"
      >
        {content}
      </Tooltip>
    ) : (
      content
    );
  };

  return <div className={classes.dietQualityLink}>{renderContent()}</div>;
};

export default PatientAssessmentLinkComponent;
